import type { HttpErrorResponse } from '@angular/common/http';

import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { EraStatuses, IEra } from 'src/app/shared/interfaces/era/era.interface';
import { AlertService } from 'src/app/shared/services/alert.service';
import { EraService } from 'src/app/shared/services/era/era.service';
import { FileStatus } from 'src/graphql/client/generated-types';

@Component({
  selector: 'app-era-file-info-modal',
  templateUrl: './era-file-info-modal.component.html',
})
export class EraFileInfoModalComponent {
  era: IEra;
  statuses: FileStatus[];

  constructor(
    private activeModal: NgbActiveModal,
    private eraService: EraService,
    private alertService: AlertService,
  ) {}

  changeStatus(era: IEra, statusKey: string) {
    const params = {
      Filenames: [this.era.inputFilename],
      Status: EraStatuses[statusKey],
      X_GROUP_ID: era.groupId,
    };

    this.eraService.updateStatus(params).subscribe({
      next: () => {
        this.alertService.success(
          `Status has been successfully changed to ${EraStatuses[statusKey]}`,
        );
      },
      error: (error) => {
        this.alertService.error(error as HttpErrorResponse | string);
      },
    });
  }

  close() {
    this.activeModal.dismiss();
  }
}
